import type { Tariff } from '../model/Quote.types';
import { CYBER_ADDON_ID } from './Quote.constants';

export function selectMinPriceTariff(tariffs: Tariff[]) {
  return tariffs.reduce((acc, current) => {
    const minPrice = Math.min(acc.prices.annual, current.prices.annual);
    return minPrice === acc.prices.annual ? acc : current;
  });
}

export function extractPricePropsFromTariff(tariffs: Tariff[]) {
  const tariff = selectMinPriceTariff(tariffs);
  const { discount, prices } = tariff;
  const { annual, monthly } = prices;
  return { annual: annual ?? 0, monthly: monthly ?? 0, discount: discount ?? 0 };
}

export function isErrorWithQuoteId(error: any): error is { quoteId: string } {
  return error && error.quoteId;
}

export const isCyberAddon = (id: string) => id === CYBER_ADDON_ID;
